// smooth scroll

document.querySelector(
'.ms-race-button'
)
.addEventListener(
'click',
function(e){

e.preventDefault();

document.querySelector(
'#race-events'
)
.scrollIntoView({

behavior:'smooth'

});

});




// Number animation
const counters = document.querySelectorAll('.data-item strong');

counters.forEach((counter) => {
  const target = Number(
    counter.dataset.number.replace(/,/g, '')
  );

  if (!Number.isFinite(target)) return;

  let count = 0;
  const increment = Math.ceil(target / 80);

  const timer = setInterval(() => {
    count += increment;

    if (count >= target) {
      count = target;
      clearInterval(timer);
    }

    counter.textContent = count.toLocaleString('en-US');
  }, 30);
});





window.addEventListener(
"scroll",
function(){


const nav =
document.querySelector(
".ms-race-nav"
);


if(window.scrollY>500){

nav.classList.add(
"active"
);


}else{


nav.classList.remove(
"active"
);


}


});




const observer =
new IntersectionObserver(

entries=>{


entries.forEach(entry=>{


if(entry.isIntersecting){


entry.target.classList.add(
"show"
);


}


});


},

{
threshold:.15
}


);

/* 图片 Parallax 效果 */

document
.querySelectorAll(
".reveal"
)
.forEach(
item=>observer.observe(item)
);




window.addEventListener(
"scroll",

()=>{


document
.querySelectorAll(
".parallax-img"
)
.forEach(img=>{


let speed =
window.scrollY*0.08;


img.style.transform =
`
translateY(${speed}px)
scale(1.05)
`;


});


});

/*   film  */

document
.querySelectorAll(
'.ms-race-play'
)
.forEach(btn=>{


btn.addEventListener(
'click',

()=>{


let card =
btn.closest(
'.ms-race-film-card'
);


let video =
card.querySelector(
'.ms-race-film-video'
);



card.classList.add(
'is-playing'
);



video.play();



});



});



/*   film copy */

document
.querySelectorAll(
'.ms-race-play1'
)
.forEach(btn=>{


btn.addEventListener(
'click',

()=>{


let card =
btn.closest(
'.ms-race-film-card1'
);


let video =
card.querySelector(
'.ms-race-film-video1'
);



card.classList.add(
'is-playing'
);



video.play();



});



});


document.addEventListener("DOMContentLoaded", function () {
  const galleries = document.querySelectorAll(".ms-gallery");

  galleries.forEach(function (gallery) {
    const track = gallery.querySelector(".gallery-track");
    const group = gallery.querySelector(".gallery-group");

    if (!track || !group || track.dataset.initialized === "true") {
      return;
    }

    track.dataset.initialized = "true";

    const originalImages = Array.from(group.querySelectorAll("img"));

    let isHovered = false;
    let isDragging = false;
    let isTouching = false;
    let startX = 0;
    let startScrollLeft = 0;
    let lastTime = performance.now();

    /* 自动轮播速度，数值越大速度越快 */
    const scrollSpeed = 32;

    function waitForImages() {
      return Promise.all(
        originalImages.map(function (img) {
          if (img.complete) {
            if (img.decode) {
              return img.decode().catch(function () {});
            }

            return Promise.resolve();
          }

          return new Promise(function (resolve) {
            img.addEventListener("load", resolve, { once: true });
            img.addEventListener("error", resolve, { once: true });
          });
        })
      );
    }

    waitForImages().then(function () {
      /* 复制图片组，实现无缝循环 */
      const clone = group.cloneNode(true);

      clone.setAttribute("aria-hidden", "true");

      clone.querySelectorAll("img").forEach(function (img) {
        img.alt = "";
        img.loading = "lazy";
        img.draggable = false;
      });

      originalImages.forEach(function (img) {
        img.draggable = false;
      });

      track.appendChild(clone);

      function getLoopWidth() {
        const gap = parseFloat(
          getComputedStyle(track).columnGap ||
          getComputedStyle(track).gap ||
          0
        );

        return group.offsetWidth + gap;
      }

      function normalizeScrollPosition() {
        const loopWidth = getLoopWidth();

        if (!loopWidth) return;

        if (track.scrollLeft >= loopWidth) {
          track.scrollLeft -= loopWidth;
        } else if (track.scrollLeft < 0) {
          track.scrollLeft += loopWidth;
        }
      }

      function animate(currentTime) {
        const deltaTime = Math.min(
          (currentTime - lastTime) / 1000,
          0.05
        );

        lastTime = currentTime;

        const reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;

        if (
          !isHovered &&
          !isDragging &&
          !isTouching &&
          !reduceMotion
        ) {
          track.scrollLeft += scrollSpeed * deltaTime;
          normalizeScrollPosition();
        }

        requestAnimationFrame(animate);
      }

      requestAnimationFrame(animate);

      /* 鼠标移入暂停，移出继续 */
      gallery.addEventListener("mouseenter", function () {
        isHovered = true;
      });

      gallery.addEventListener("mouseleave", function () {
        isHovered = false;

        if (isDragging) {
          stopDragging();
        }
      });

      /* 鼠标按住开始拖动 */
      track.addEventListener("pointerdown", function (event) {
        if (event.pointerType === "touch") {
          isTouching = true;
          return;
        }

        isDragging = true;
        startX = event.clientX;
        startScrollLeft = track.scrollLeft;

        track.classList.add("is-dragging");
        track.setPointerCapture(event.pointerId);
      });

      /* 鼠标左右移动 */
      track.addEventListener("pointermove", function (event) {
        if (!isDragging || event.pointerType === "touch") {
          return;
        }

        event.preventDefault();

        const moveDistance = event.clientX - startX;

        track.scrollLeft = startScrollLeft - moveDistance;
        normalizeScrollPosition();
      });

      /* 停止拖动 */
      function stopDragging(event) {
        isDragging = false;
        track.classList.remove("is-dragging");

        if (
          event &&
          event.pointerId !== undefined &&
          track.hasPointerCapture(event.pointerId)
        ) {
          track.releasePointerCapture(event.pointerId);
        }
      }

      track.addEventListener("pointerup", stopDragging);
      track.addEventListener("pointercancel", stopDragging);

      /* 手机端触摸时暂停自动轮播 */
      track.addEventListener(
        "touchstart",
        function () {
          isTouching = true;
        },
        { passive: true }
      );

      track.addEventListener(
        "touchend",
        function () {
          isTouching = false;
          normalizeScrollPosition();
        },
        { passive: true }
      );

      track.addEventListener(
        "touchcancel",
        function () {
          isTouching = false;
        },
        { passive: true }
      );

      /* 手动滚动后处理无缝循环 */
      track.addEventListener(
        "scroll",
        function () {
          if (isDragging || isTouching) {
            normalizeScrollPosition();
          }
        },
        { passive: true }
      );
    });
  });
});










